const NON_DIGIT_CHARACTERS = /[^0-9]/g;
const ONLY_DIGITS_REGEX = /^\d+$/;

export function capitalizeWord(sentence: string): string {
  if (!sentence) {
    return sentence;
  }
  return sentence.charAt(0).toUpperCase() + sentence.slice(1).toLowerCase();
}

export function toTitleCase(str: string) {
  return str.replace(/\w\S*/g, (txt) => {
    return capitalizeWord(txt);
  });
}

export const allowOnlyOneSpace = (inputString: string) => {
  return inputString.replace(/\s+/g, ' ').trim();
};

export const filterDigits = (text: string): string => {
  return text.replace(NON_DIGIT_CHARACTERS, '');
};

export const containsOnlyDigits = (text: string): boolean => {
  return ONLY_DIGITS_REGEX.test(text);
};

export const stripRegexCharacters = (str: string) => {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '');
};
